/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import {GenericObject} from '@ion/core/src/types/entities';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {ACTIONS} from '@ion/dls/src/editors/features/helpers';

let cachedFeatures = null;

/**
 * Provides a utility hook to check the current user role has list
 * of Telecrypt feature enabled.
 *
 * ```typescript
 *
 * import {useTeleCryptModuleFeatures} from '@ion/applications/src/hooks/';
 *
 * const teleCryptFeatures = useTeleCryptModuleFeatures();
 *
 * ```
 *
 */
export const useTeleCryptModuleFeatures = (Features: GenericObject) => {
  if (cachedFeatures) {
    return cachedFeatures;
  }

  const extendedAttribute = Features.getExtendedAttribute();
  const userFeatures      = safeJSONParse(extendedAttribute);
  const servicesFeatures  = userFeatures?.features?.find((item) => Features?.isServiceEnablementFeature(item?.id));
  const teleCryptFeatures = servicesFeatures?.features?.find(item => Features?.isTeleCryptFeature(item?.id));

  const access = {
    hasRead   : false,
    hasUpdate : false
  };

  if (teleCryptFeatures) {
    const moduleMap = teleCryptFeatures?.modules?.reduce((acc, m) => ({...acc, [m.name]: m?.enabled}), {});

    access.hasRead   = moduleMap?.[ACTIONS.READ] || false;
    access.hasUpdate = moduleMap?.[ACTIONS.UPDATE] || false;

    cachedFeatures = access;
    return cachedFeatures;
  }
};

export default useTeleCryptModuleFeatures;
